// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_workshops_workshops_module_ts":"f1942edee81cfd9b","src_app_blog_blog_module_ts":"0977332fb55a5343","src_app_faq_faq_module_ts":"66e8bdcf06262d2b","src_app_coc_coc_module_ts":"dea6ea2e9163d39d"}[chunkId] + ".js";
};